import React, { useState, useEffect } from "react";
import { RoundedButton } from "../../../../../elements";
import { vaultStore } from "../../store/VaultStore";

import {
  ModalWrapper,
  ModalContent,
  ModalBody,
  ModalFooter,
  InputLabel,
  InputWrapper,
  StyledInput,
} from "./RenameVaultFileModal.styled";
import { useLocation } from "react-router-dom";
import { useStore } from "../../../../../hooks";

const RenameVaultFileModal = ({
  isOpen,
  onClose,
  onSubmit,
  currentName,
  fileId,
  created_by,
  status,
}) => {
  const { authStore } = useStore();
  const [fileName, setFileName] = useState(currentName || "");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const location = useLocation();
  const fullSearch = location.search + location.hash;
  const searchParams = new URLSearchParams(fullSearch.replace("#", "%23"));
  const folderId = decodeURIComponent(searchParams.get("id") || "");

  useEffect(() => {
    if (isOpen && currentName) {
      setFileName(currentName);
    }
  }, [isOpen, currentName]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.stopPropagation();
    if (!fileName.trim()) return;

    setIsSubmitting(true);
    const success = await vaultStore.renameDocumentFile(
      folderId,
      authStore.selectedAccount.id,
      fileId,
      fileName.trim(),
      created_by,
      status
    );
    setIsSubmitting(false);

    if (success) {
      onSubmit(fileName.trim());
    }
  };

  const handleClose = (e) => {
    e.stopPropagation();
    onClose();
  };

  return (
    <ModalWrapper onClick={(e) => e.stopPropagation()}>
      <ModalContent data-testid="rename-vault-file-modal" role="dialog" onClick={(e) => e.stopPropagation()}>
        <ModalBody>
          <InputWrapper>
            <InputLabel htmlFor="rename-file-input" data-testid="rename-file-label">File Name</InputLabel>
            <StyledInput
              id="rename-file-input"
              type="text"
              value={fileName}
              onChange={(e) => setFileName(e.target.value)}
              placeholder="Enter file name"
              disabled={isSubmitting}
              onClick={(e) => e.stopPropagation()}
            />
          </InputWrapper>
        </ModalBody>
        <ModalFooter>
          <RoundedButton
            kind="default"
            outline
            onClick={handleClose}
            disabled={isSubmitting}
          >
            Cancel
          </RoundedButton>
          <RoundedButton
            kind="blue"
            onClick={handleSubmit}
            disabled={isSubmitting || !fileName.trim()}
          >
            {isSubmitting ? "Renaming..." : "Rename"}
          </RoundedButton>
        </ModalFooter>
      </ModalContent>
    </ModalWrapper>
  );
};

export default RenameVaultFileModal;
